import React from "react";
import { useFormik, Formik, Form } from "formik";
import * as Yup from "yup";
import { createPromoCodeAsync, updatePromoCodeAsync } from "../../redux/promoApi";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { Col, Row, Modal } from "react-bootstrap";

const AddPromoCode = ({ selectedPromo, isLoading, showPromoModal, setShowPromoModal }) => {
  const dispatch = useDispatch();

  const AddPromoFormSchema = () =>
    Yup.object().shape({
      name: Yup.string().trim().min(2, "Minimum 2 characters").max(50, "Maximum 50 characters").required("Name is required"),
      code: Yup.string().trim().min(2, "Minimum 2 characters").max(50, "Maximum 50 characters").required("Code is required"),
      freeCoins: Yup.number().min(0, "Must be >= 0").required("Free Coins is required"),
      maxUsage: Yup.mixed().test('is-number-or-empty', 'Must be a valid number', (val) => val === '' || val === null || val === undefined || !isNaN(Number(val))),
    });

  const onHideModal = () => {
    setShowPromoModal(false);
  };

  return (
    <>
      <Modal show={showPromoModal} onHide={() => onHideModal()} centered className="def_modal delete_modal" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">{selectedPromo && selectedPromo._id ? "Edit Promo Code" : "Add Promo Code"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              name: (selectedPromo && selectedPromo.name) || "",
              code: (selectedPromo && selectedPromo.code) || "",
              freeCoins: (selectedPromo && selectedPromo.freeCoins) || 100,
              maxUsage: (selectedPromo && (selectedPromo.maxUsage ?? '')) || '',
            }}
            validationSchema={AddPromoFormSchema}
            onSubmit={(values) => {
              const payload = { ...values };
              if (payload.maxUsage === '' || payload.maxUsage === null || payload.maxUsage === undefined) {
                payload.maxUsage = 'unlimited';
              } else {
                payload.maxUsage = Number(payload.maxUsage);
              }
              if (!selectedPromo || !selectedPromo._id) {
                dispatch(createPromoCodeAsync(payload, setShowPromoModal));
              } else {
                dispatch(updatePromoCodeAsync(selectedPromo._id, payload, setShowPromoModal));
              }
            }}
          >
            {({ values, errors, touched, handleChange, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Name</label>
                      <input
                        placeholder="Enter Name"
                        type="text"
                        name="name"
                        value={values.name}
                        className={errors.name && touched.name ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.name}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Code</label>
                      <input
                        placeholder="Enter Code"
                        type="text"
                        name="code"
                        value={values.code}
                        className={errors.code && touched.code ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.code && errors.code ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.code}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Free Coins</label>
                      <input
                        placeholder="Enter Free Coins"
                        type="number"
                        name="freeCoins"
                        value={values.freeCoins}
                        className={errors.freeCoins && touched.freeCoins ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.freeCoins && errors.freeCoins ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.freeCoins}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Maximum Usage Limit (leave blank for Unlimited)</label>
                      <input
                        placeholder="e.g. 10"
                        type="number"
                        name="maxUsage"
                        value={values.maxUsage}
                        className={errors.maxUsage && touched.maxUsage ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.maxUsage && errors.maxUsage ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.maxUsage}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group  mb-0 mt-4">
                      <div className="form-group mr-5 mb-1 mt-2">
                        <button type="submit" className="btn btn-blue spinnerBtn add-avtar-btn" disabled={isLoading}>
                          <span>{selectedPromo && selectedPromo._id ? "Update" : "Add"}</span>
                          {isLoading && (
                            <div className="ml-3 basic-verification-loader text-center">
                              <CircularProgress />
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AddPromoCode; 